import { BalanceLabel } from './BalanceLabel'
import { TradeTokenInput } from './TradeTokenInput'
import { TradeTokenSelect } from './TradeTokenSelect'
import { TradeForm, TradeFormBody } from './TradeForm'
import { TradeButton } from './TradeButton'
import { TradeTipRow } from './TradeTipRow'
import { Divider, FootNote, Spacer, Stack } from './Layout'
import { TokenRow } from './TokenRow'
import { TradeStatusArea } from './TradeStatus'
import { TradeFlow } from './TradeFlow'
import { Network } from './Network'

export type TradeFormComponent = typeof TradeForm & {
  Input: typeof TradeTokenInput
  TokenSelect: typeof TradeTokenSelect
  BalanceLabel: typeof BalanceLabel
  Button: typeof TradeButton
  TipRow: typeof TradeTipRow
  TokenRow: typeof TokenRow
  Divider: typeof Divider
  Stack: typeof Stack
  Body: typeof TradeFormBody
  Spacer: typeof Spacer
  Status: typeof TradeStatusArea
  TradeFlow: typeof TradeFlow
  Network: typeof Network
  FootNote: typeof FootNote
}
;(TradeForm as TradeFormComponent).Input = TradeTokenInput
;(TradeForm as TradeFormComponent).TokenSelect = TradeTokenSelect
;(TradeForm as TradeFormComponent).BalanceLabel = BalanceLabel
;(TradeForm as TradeFormComponent).Button = TradeButton
;(TradeForm as TradeFormComponent).TipRow = TradeTipRow
;(TradeForm as TradeFormComponent).Divider = Divider
;(TradeForm as TradeFormComponent).Stack = Stack
;(TradeForm as TradeFormComponent).Body = TradeFormBody
;(TradeForm as TradeFormComponent).Spacer = Spacer
;(TradeForm as TradeFormComponent).TokenRow = TokenRow
;(TradeForm as TradeFormComponent).Status = TradeStatusArea
;(TradeForm as TradeFormComponent).TradeFlow = TradeFlow
;(TradeForm as TradeFormComponent).Network = Network
;(TradeForm as TradeFormComponent).FootNote = FootNote

export default TradeForm as TradeFormComponent
